import React from 'react';
import { Link } from '@reach/router';
import './styles.less';
import { AnalyticsAction } from '@/config/analytics';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/reducers';

interface LandingNavbarProps {
  logo?: string;
  navMenus?: {
    label: string;
    url: string;
    analytics: AnalyticsAction;
  }[];
  button?: {
    label: string;
    link?: string;
    analytics?: AnalyticsAction;
  };
  defaultMenu?: {
    label: string;
    url: string;
  };
  showHeaderName?: boolean;
  bankName?: string;
}

const LandingNavbar: React.FC<LandingNavbarProps> = ({ logo, bankName, showHeaderName }) => {
  const error: any = useSelector((state: RootState) => state.errors.FETCH_ENTITY);

  return (
    <div className="LandingNavbar">
      <Link to="/">
       <div className="LandingNavbar-logo">
        <img src="/assets/images/logo.png" alt='logo'  />
       </div>
      </Link>
    </div>
  );
};

export default LandingNavbar;
